import { TranslationEntry } from '@longy/common'
import { Skeleton } from '@longy/web-components'
import { createFileRoute } from '@tanstack/react-router'

import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'
import { PackageCard } from '../components/landing/PackageCard'
import { api } from '../core/trpc'
import { buildOgMeta } from '../utils/og'

const packageImages = [
    'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=800&q=80',
    'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80',
    'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=800&q=80',
]

const PackagesPage = () => {
    const { data: packages, isLoading } = api.package.getPublicPackages.useQuery()

    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <section className="mx-auto w-full max-w-[1280px] px-6 py-24">
                    <div className="mb-16">
                        <h1 className="mb-4 text-3xl font-bold text-brand-dark md:text-4xl">
                            Csomagok
                        </h1>
                        <p className="text-brand-gray">Válassz az elérhető csomagjaink közül</p>
                    </div>

                    {isLoading ? (
                        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                            {[1, 2, 3].map((i) => (
                                <div
                                    key={i}
                                    className="overflow-hidden rounded-3xl border border-slate-100"
                                >
                                    <Skeleton className="h-72 w-full" />
                                    <div className="p-8">
                                        <div className="mb-4 flex justify-between">
                                            <Skeleton className="h-6 w-32" />
                                            <Skeleton className="h-6 w-24" />
                                        </div>
                                        <Skeleton className="mb-8 h-16 w-full" />
                                        <Skeleton className="h-12 w-full rounded-full" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : packages && packages.length > 0 ? (
                        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                            {packages.map((pkg, index) => (
                                <PackageCard
                                    key={pkg.id}
                                    name={pkg.name as TranslationEntry}
                                    description={pkg.description as TranslationEntry}
                                    imageUrl={packageImages[index % packageImages.length]}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="py-16 text-center">
                            <p className="text-lg text-brand-gray">
                                Jelenleg nem érhetők el csomagok.
                            </p>
                        </div>
                    )}
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/packages')({
    component: PackagesPage,
    loader: async ({ context }) => {
        const results = await Promise.allSettled([
            context.apiUtils.package.getPublicPackages.ensureData(),
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: results[2].status === 'fulfilled' ? results[2].value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title: 'Long-Y - Csomagok',
            url: `${import.meta.env.VITE_WEB_URL || ''}/packages`,
            websiteSettings: loaderData?.websiteSettings,
        }),
    }),
})
